/* unplugin-vue-components disabled */import script from "./configuration.vue?vue&type=script&setup=true&lang=ts"
export * from "./configuration.vue?vue&type=script&setup=true&lang=ts"

import "./configuration.vue?vue&type=style&index=0&id=2eeaf43f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eeaf43f"]])

export default __exports__